

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/; Secure";
}



// Get url parameter
export function getUrlParameter(url, parameter){
  let urlData = new URL(url);
  return urlData.searchParams.get(parameter);
}


// get all url parameters
export function getUrlParameters(url) {
  let params = {};
  (url + '?').split('?')[1].split('&').forEach(function (pair) {
    pair = (pair + '=').split('=').map(decodeURIComponent);
    if (pair[0].length) {
      params[pair[0]] = pair[1];
    }
  });
  return params;
}



// Get url with updated parameter
//    returns url with updated parameter
// window.history.replaceState('', '', updateUrlParameter(window.location.href, "popup", 'popup-254'));
export function updateUrlParameter(url, param, paramVal){
  var TheAnchor = null;
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    var tmpAnchor = additionalURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if(TheAnchor)
      additionalURL = TheParams;
    tempArray = additionalURL.split("&");
    for (var i=0; i<tempArray.length; i++){
      if(tempArray[i].split('=')[0] != param){
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }
  else{
    var tmpAnchor = baseURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor  = tmpAnchor[1];
    if(TheParams)
      baseURL = TheParams;
  }
  if(TheAnchor)
    paramVal += "#" + TheAnchor;

  let rows_txt = temp
  if (paramVal !== '') rows_txt += "" + param + "=" + paramVal;

  let returnUrl = baseURL
  if (newAdditionalURL !== '' || rows_txt !== '') returnUrl += '?'
  if (newAdditionalURL !== '') returnUrl += newAdditionalURL
  if(rows_txt !== '' && rows_txt !== '&') returnUrl += rows_txt

  return returnUrl
}
